<template>
    <div class="login">


        <b-row align-v="center" align-h="center">
            <b-col md="5">


                <LoginWindow v-if="login" @register="registerUser" />

                <div v-else>
                    <h1 class="text-center">Registrering</h1>

                    <div v-if="errors.length">
                        <b-alert show variant="danger" class="errors">
                            <ul>
                                <li  v-for="error in errors" :key="error">
                                    {{ error }}
                                </li>
                            </ul>
                        </b-alert>
                    </div>



                    <div v-else-if="messages.length">
                        <b-alert show variant="secondary" class="errors">
                            <ul>
                                <li  v-for="msg in messages" :key="msg">
                                    {{ msg }}
                                </li>
                            </ul>
                        </b-alert>

                        <b-button @click="loginRedirect" variant="primary">Logg inn</b-button>
                    </div>



                    <div class="text-center  my-2" v-else>
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Laster...</strong>
                    </div>


                </div>



            </b-col>

        </b-row>


    </div>
</template>


<script>

import LoginWindow from '@/components/LoginWindow.vue'

export default {
    name: 'Login',
    components: {
        LoginWindow
    },
    data() {
        return {
            login: true,
            cardId:null,
            pin:null,
            errors: [],
            messages: [],
        }
    },
    mounted() {

        // Fetch params from query string and show success if done with bankid
        let query = this.$route.query;
        let key = query.state;

        // BankID error
        if (key && query.error) {
            this.login = false;
            this.$api.patch(`/register/${key}/`, {
                error: query.error
            });
        }
        // BankID success
        else if ( key && query.session_state ) {
            this.login = false;
            let session_state = query.session_state;
            let code = query.code;

            this.$api.patch(`/register/${key}/`, {
                session_state: session_state,
                code: code,
            }).then((response) => {
                this.messages.push('Du er nå registrert hos oss. Vennligst logg inn.')
            }).catch((error) => {

                if (error.response) {
                    let code = error.response.status;
                    console.log(code)
                    switch (code) {
                        case 400: this.errors.push('Noe gikk galt under registreringen.'); break;
                        case 403: this.messages.push('Du er allerede registrert.'); break;
                        default:   this.errors.push('Noe gikk galt under registreringen.'); break;
                    }
                }
                else {
                    this.errors.push('Noe gikk galt under registreringen.')
                }

            });
        }

    },
    methods: {
        registerUser(data) {

            this.cardId = data.cardId
            this.pin = data.pin

            // Register user with API
            this.$api.post(`/register/`, {
                card_id: this.cardId,
                pin: this.pin
            })
            .then((response) => {

                // Send user to BankID window
                window.location = response.data.redirect_url;

            })
            .catch((error) => {
                this.errors.push('Du har ikke oppgitt rett informasjon.')
            });
        },
        loginRedirect() {
            this.login = true
            // this.$router.push({path:'/logginn',query:null});
        }

    }
}
</script>



<style scoped lang="scss">


.errors ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}

</style>
